import React from 'react';
import { TermsConditionsText } from '@/lib/react-intl/TranslatedTexts';
import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { CommonModal } from '@/components/modal/index';
import { DangerouslyHtml } from '@/components/item';
// import { useGetTermsConditions } from '@/hooks/CommonRequests';
import {
  ContentsWrapper,
  ModalWrapper,
  PrivacyPolicyContentsContainer,
} from '@/components/modal/PrivacyPolicyModal';
import { staticTermsCondition } from '@/static/static';

const TermsConditionsModal = ({ openModal, setOpenModal }) => {
  // const { data } = useGetTermsConditions();

  const currentLanguage = localStorage.getItem(LOCAL_LANGUAGE)
    ? localStorage.getItem(LOCAL_LANGUAGE)
    : 'en';

  const data = staticTermsCondition[currentLanguage];

  return (
    <CommonModal
      openModal={openModal}
      setOpenModal={setOpenModal}
      fixCloseButton
      modalName={<TermsConditionsText />}
      width="100%"
    >
      <ModalWrapper>
        <div style={{ width: '100%', textAlign: 'left' }}>
          <ContentsWrapper disableTopBorder={true}>
            <PrivacyPolicyContentsContainer>
              <DangerouslyHtml value={data?.field_terms_condition} />
            </PrivacyPolicyContentsContainer>
          </ContentsWrapper>
        </div>
      </ModalWrapper>
    </CommonModal>
  );
};

export default TermsConditionsModal;
